import React from 'react'
import '../../stylings/feature.css'
import { FaGroupArrowsRotate, FaHandsHoldingCircle } from 'react-icons/fa6'
import { LuAtom } from 'react-icons/lu'

const Feature = () => {
    return (
        <div className='feature-container'>
            <div className="row">
                <div className="column col-sm-4">
                    <div className="card-wrapper green">
                        <div className="svg-container green">
                            <LuAtom />
                        </div>
                        <div className="card-body">
                            <h3 className='green'>Educate</h3>
                            <p><i>"Education is the most powerful weapon which you can use to change the world"</i></p>
                            <p>- Nelson Mandela</p>
                        </div>
                    </div>
                </div>

                <div className="column col-sm-4">
                    <div className="card-wrapper orange">
                        <div className="svg-container orange">
                            <FaHandsHoldingCircle />
                        </div>
                        <div className="card-body">
                            <h3 className='orange'>Empower</h3>
                            <p><i>"The future belongs to those who believe in the beauty of their dreams"</i></p>
                            <p>- Eleanor Roosevelt</p>
                        </div>
                    </div>
                </div>

                <div className="column col-sm-4">
                    <div className="card-wrapper theme">
                        <div className="svg-container theme">
                            <FaGroupArrowsRotate />
                        </div>
                        <div className="card-body">
                            <h3 className='theme'>Transform</h3>
                            <p><i>"You must be the change you wish to see in the world"</i></p>
                            <p>- Mahatma Gandhi</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Feature
